export default {
  EXTERNAL_GROUP_TYPE: 'external_provider',
  IN_NETWORK_GROUP_TYPE: 'in_network',
  OON_GROUP_TYPE: 'out_of_network'
};